import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getFilterDataForDropdown(
    FilterId: number,
    search: string = '',
    page: number = 1,
    pageSize: number = 20,
  ) {
    const params = {
      MaxResultCount: pageSize,
      FilterId: FilterId,
      SkipCount: (page - 1) * pageSize,
      Filter: search,
    };

    const URL = `${this.baseUrl}TableFilter/GetFilterDataForDropdown`;
    return this.http.get<any>(URL, { headers: this.headers, params }).pipe(map((r) => r.result));
  }

  getTableAndChartData(body: any) {
    const URL = `${this.baseUrl}table/getTableAndChartDataQuery`;
    return this.http.post<any>(URL, body, { headers: this.headers }).pipe(map((r) => r.result));
  }
}
